<template>
  <div>
    <van-nav-bar
      title="公告详情"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <div style="padding: 0px 10px">
      <p v-html="$store.state.home_notice_content" class="content">
        {{ $store.state.home_notice_content }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeDetailed",
  data() {
    return {};
  },
  methods: {
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  margin: 2px 0px;
  font-weight: bold;
}

.content {
  width: 100%;
  margin: 2px 0px;
  font-size: 14px;
}
.content >>> img {
  width: 100%;
}
.content >>> p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NoticeDetailed.vue